import { createContext, useContext } from 'react';
const DEFAULT_DEACTIVATE_PRODUCT_ACTION = () => {};
export const DeactivateProductActionContext = /*#__PURE__*/createContext(DEFAULT_DEACTIVATE_PRODUCT_ACTION);
export const useDeactivateProductAction = () => useContext(DeactivateProductActionContext);